import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../../theme/style-helpers';
import { Table } from '../css';

export const AdditionalServicesTable = styled(Table)`
    row-gap: 16px;

    ${MediaQuery.medium(css`
        grid-template-columns: 1fr 1fr;
        grid-auto-rows: 1fr;
        row-gap: 24px;
    `)};

    ${MediaQuery.xLarge(css`
        display: flex;
        justify-content: start;
    `)};
`;

export const AdditionalServiceItem = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    margin-right: 137px;

    &:last-child {
        margin-right: 0px;
    }
`;

export const AdditionalServiceLabel = styled.p`
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};
`;
